module.exports = __webpack_public_path__ + "static/media/garderobe_richtig_personal.c369f471.jpg";